<template>
    <el-form>
        <div class="row" id="advanced-search">
            <div class="col-sm-3 col-xs-6 col">
                <el-popover placement="bottom" v-model="visible2" class="filter">
                    <small><strong>{{'Budget Range' | language}} (¥{{$store.state.search.miniBudget}}K - ¥{{$store.state.search.maxBudget}}K)</strong></small>
                    <div class="block" v-loading="loading">
                        <el-slider style="padding: 0 .5rem" v-model="budget" range
                            :format-tooltip="formatTooltip" :min="$store.state.search.miniBudget" :max="$store.state.search.maxBudget" :step="5" @change="changeBudget">
                        </el-slider>
                    </div>
                    <el-button type="text" size="mini" slot="reference">
                        {{'Budget' | language}}<br><strong v-if="$store.state.search.query.budget && $store.state.search.query.budget.length > 0"><small style="color:#424242">¥{{$store.state.search.query.budget[0]}}K - ¥{{$store.state.search.query.budget[1]}}K</small></strong>
                    </el-button>
                </el-popover>
            </div>
            <div class="col-sm-3 col-xs-6 col">
                <el-popover placement="bottom" v-model="visible3" class="filter">
                    <small><strong>{{'Walk to Station' | language}} ({{$store.state.search.miniDistance}}mins - {{$store.state.search.maxDistance}}mins)</strong></small>
                    <div class="block" v-loading="loading">
                        <el-slider style="padding: 0 .5rem" v-model="walkDistance"
                            :format-tooltip="distancePopup" :min="$store.state.search.miniDistance" :max="$store.state.search.maxDistance" :step="5" @change = "changeDistance">
                        </el-slider>
                    </div>

                    <el-button type="text" size="mini" slot="reference">{{'Walk to Station' | language}}<br><strong v-if="$store.state.search.query.walkDistance"><small style="color:#424242">Less than {{$store.state.search.query.walkDistance}} mins</small></strong></el-button>
                </el-popover>
            </div>
            <div class="col-sm-3 col-xs-6 col">
                <el-popover placement="bottom" v-model="visible4" class="filter">
                    <small><strong>{{'Least Number of Bedrooms' | language}} ({{$store.state.search.miniBedrooms}} to {{$store.state.search.maxBedrooms}})</strong></small>
                    <div class="block" v-loading="loading">
                        <el-slider style="padding: 0 .5rem" v-model="bedroom"
                            :format-tooltip="bedroomPopup" :min="$store.state.search.miniBedrooms" :max="$store.state.search.maxBedrooms" :step="1" @change= "changeBedroom">
                        </el-slider>
                    </div>

                    <el-button type="text" size="mini" slot="reference">{{'Bedrooms' | language}}<br><strong v-if="$store.state.search.query.bedroom"><small style="color:#424242">At least {{$store.state.search.query.bedroom}} bedrooms</small></strong></el-button>
                </el-popover>
            </div>
            <div class="col-sm-3 col-xs-6 col">
                <el-popover placement="bottom" v-model="visible6" class="filter">
                    <small><strong>{{'Property Features' | language}}</strong></small>

                    <div class="checkboxes" v-loading="loading">
                        <el-checkbox :label="'Parking Available' | language" v-model="$store.state.search.parking" @change="apply"></el-checkbox>
                        <el-checkbox :label="'Security Entrance' | language" v-model="$store.state.search.security" @change="apply"></el-checkbox>
                        <el-checkbox :label="'Concierge' | language" v-model="$store.state.search.concierge"  @change="apply"></el-checkbox>
                        <el-checkbox :label="'Pet Allowed' | language" v-model="$store.state.search.pet" @change="apply" ></el-checkbox>
                        <el-checkbox :label="'Balcony' | language" v-model="$store.state.search.balcony"  @change="apply"></el-checkbox>
                        <el-checkbox :label="'Private Yard' | language" v-model="$store.state.search.yard"  @change="apply"></el-checkbox>
                        <el-checkbox :label="'AC/Heating' | language" v-model="$store.state.search.heating"  @change="apply"></el-checkbox>
                        <el-checkbox :label="'Dishwasher' | language" v-model="$store.state.search.dishwasher"  @change="apply"></el-checkbox>
                        <el-checkbox :label="'Dryer' | language" v-model="$store.state.search.dryer"  @change="apply"></el-checkbox>
                        <el-checkbox :label="'Refrigerator' | language" v-model="$store.state.search.refrigerator"  @change="apply"></el-checkbox>

                    </div>

                    <el-button type="text" size="mini" slot="reference" id="property_features">{{'Property Features' | language}}<br>
                        <strong>
                            <small style="color:#424242" v-if="$store.state.search.parking">{{'Parking Available' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.security">{{'Security Entrance' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.concierge">{{'Concierge' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.pet">{{'Pet Allowed' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.balcony">{{'Balcony' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.yard">{{'Private Yard' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.heating">{{'AC/Heating' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.dishwasher">{{'Dishwasher' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.dryer">{{'Dryer' | language}}</small>
                            <small style="color:#424242" v-if="$store.state.search.refrigerator">{{'Refrigerator' | language}}</small>
                        </strong>
                    </el-button>
                </el-popover>

                <el-tooltip effect="dark" content="Reset filters" placement="bottom">
                    <el-button type="text" icon="el-icon-refresh-right" id="reset-filters" @click="reset"></el-button>
                </el-tooltip>
            </div>
        </div>

        <el-popover
            popper-class="advanced-search-popover"
            placement="bottom"
            title="Filters"
            trigger="click"
            v-model="visible">

            <el-button slot="reference" size="mini" id="filters-btn">Filters</el-button>

            <div id="advanced-search-mobile">
                <div class="col">
                    <small><strong>{{'Budget Range' | language}} (¥{{$store.state.search.miniBudget}}K - ¥{{$store.state.search.maxBudget}}K)</strong></small>
                    <div class="block">
                        <el-slider style="padding: 0 .5rem" v-model="budget" range
                            :format-tooltip="formatTooltip" :min="$store.state.search.miniBudget" :max="$store.state.search.maxBudget" :step="5" @change="changeBudget">
                        </el-slider>
                    </div>

                    <small style="color:#424242" v-if ="$store.state.search.query.budget && $store.state.search.query.budget.length > 0">¥{{$store.state.search.query.budget[0]}}K - ¥{{$store.state.search.query.budget[1]}}K</small>
                </div>
                <div class="col">
                    <small><strong>{{'Walk to Station' | language}} ({{$store.state.search.miniDistance}}mins - {{$store.state.search.maxDistance}}mins)</strong></small>
                    <div class="block">
                        <el-slider style="padding: 0 .5rem" v-model="walkDistance"
                            :format-tooltip="distancePopup" :min="$store.state.search.miniDistance" :max="$store.state.search.maxDistance" :step="5" @change="changeDistance">
                        </el-slider>
                    </div>

                    <small style="color:#424242" v-if="$store.state.search.query.walkDistance">Less than {{$store.state.search.query.walkDistance}} mins</small>
                </div>
                <div class="col">
                    <small><strong>{{'Least Number of Bedrooms' | language}} ({{$store.state.search.miniBedrooms}} to {{$store.state.search.maxBedrooms}})</strong></small>
                    <div class="block">
                        <el-slider style="padding: 0 .5rem" v-model="bedroom"
                            :format-tooltip="bedroomPopup" :min="$store.state.search.miniBedrooms" :max="$store.state.search.maxBedrooms" :step="1" @change="changeBedroom">
                        </el-slider>
                    </div>

                    <small style="color:#424242" v-if="$store.state.search.query.bedroom">At least {{$store.state.search.query.bedroom}} bedrooms</small>
                </div>
                <div class="col">
                    <small><strong>{{'Property Features' | language}}</strong></small>

                    <div class="checkboxes">
                        <el-checkbox :label="'Parking Available' | language" v-model="$store.state.search.parking" ></el-checkbox>
                        <el-checkbox :label="'Security Entrance' | language" v-model="$store.state.search.security" ></el-checkbox>
                        <el-checkbox :label="'Concierge' | language" v-model="$store.state.search.concierge" ></el-checkbox>
                        <el-checkbox :label="'Pet Allowed' | language" v-model="$store.state.search.pet"></el-checkbox>
                        <el-checkbox :label="'Balcony' | language" v-model="$store.state.search.balcony"></el-checkbox>
                        <el-checkbox :label="'Private Yard' | language" v-model="$store.state.search.yard"></el-checkbox>
                        <el-checkbox :label="'AC/Heating' | language" v-model="$store.state.search.heating"  ></el-checkbox>
                        <el-checkbox :label="'Dishwasher' | language" v-model="$store.state.search.dishwasher"  ></el-checkbox>
                        <el-checkbox :label="'Dryer' | language" v-model="$store.state.search.dryer"  ></el-checkbox>
                        <el-checkbox :label="'Refrigerator' | language" v-model="$store.state.search.refrigerator"  ></el-checkbox>
                    </div>
                </div>

                <el-button type="primary" size="small" @click="apply"><span>{{'Apply' | language}}</span></el-button>
                <el-button type="info" icon="el-icon-refresh-right" id="reset-filters" plain size="small" @click="reset"><span>Clear filters</span></el-button>
            </div>
        </el-popover>
    </el-form>
</template>

<script>
import utilsService from '../../services/utilsService';
import { mapState } from 'vuex'

export default {
    data() {
        return {
            visible2: false,
            visible3: false,
            visible4: false,
            visible6: false,
            clearable: true,
            checkList: [],
            visible: false,
            budget: [0, 1500],
            walkDistance: 0,
            bedroom: 0,
        }
    },
    created() {
    },
    computed: {
      ...mapState({
        loading: (state) => {
          return state.property.loading
        }
      }),
    },
    methods: {
        toSearch() {
            this.$router.push({
                path: '/properties',
                query: {}
            })
        },
        formatTooltip(val) {
            return '¥' + val + 'K'
        },
        distancePopup(val) {
            return 'Less than ' + val + ' mins'
        },
        bedroomPopup(val) {
            return val + ' bedroom(s)'
        },
        apply() {
            const params = this.$store.state.search.query
            params.security = this.$store.state.search.security ? 1 : 0
            params.parking = this.$store.state.search.parking ? 1 : 0
            params.concierge = this.$store.state.search.concierge ? 1 : 0
            params.pet = this.$store.state.search.pet ? 1 : 0
            params.balcony = this.$store.state.search.balcony ? 1 : 0
            params.yard = this.$store.state.search.yard ? 1 : 0
            params.heating = this.$store.state.search.heating ? 1 : 0
            params.dishwasher = this.$store.state.search.dishwasher ? 1 : 0
            params.dryer = this.$store.state.search.dryer ? 1 : 0
            params.refrigerator = this.$store.state.search.refrigerator ? 1 : 0
            if (this.$route.name !== 'Home'){
                this.$router.push({path:'/properties',query:params})
            }


        },
        reset() {
            this.$store.commit('search/set_reset',{})
            this.budget = [0, 1500]
            this.walkDistance = 0
            this.bedroom = 0,
            this.$router.push({...this.$route,query:utilsService.formatSearchQuery(this.$store.state.search.selectedResults)})
        },
        changeBudget(e){
            this.$store.commit('search/set_budget',e)
            this.apply()
        },
        changeDistance(e){
            this.$store.commit('search/set_distance',e)
            this.apply()
        },
        changeBedroom(e){
            this.$store.commit('search/set_bedroom',e)
            this.apply()
        }
    }
}
</script>

<style lang="scss">
    #advanced-search {
        position: relative;
        margin-right: 0;
        margin-left: 0;
        margin-top: .25rem;
        background: rgba(white, .9);
        border-radius: 3px;

        &.show-filters {
            display: flex;
        }

        .filter {
            display: inline-block;
            width: 100%;
            height: 100%;
            border-radius: 0;

            .el-button--mini {
                height: 100%;
                width: 100%;
                padding: .75rem;
                border-left: 1px solid rgba($alternate-color, .2);
                transition: ease-in-out .2s;
                border-radius: 0;

                &:hover {
                    background: white;
                }

                span {
                    font-weight: 600;

                    strong {
                        font-weight: 400;
                    }
                }
            }
        }

        .col {
            padding: 0;

            &:last-child {
                .filter {
                    .el-button--mini {
                        border-right: 1px solid rgba($alternate-color, .2);
                    }
                }
            }
        }

        #property_features {
            strong {
                display:flex;
                justify-content: center;
                flex-wrap: wrap;
                align-items: center;
                
                small + small:before {
                    content: ", ";
                }
            }
        }

        #reset-filters {
            position: absolute;
            top: 50%;
            right: -2rem;
            transform: translateY(-50%);

            i {
                font-size: 20px;
                color: rgba($alternate-color, .3);
            }

            &:hover {
                i {
                    color: $primary-color;
                }
            }
        }

        @media (max-width: 1200px) {
            #reset-filters {
                left: -2rem;
                right: auto;
            }
        }

        @media (max-width: 767px) {
            display: none;

            .col {
                &:nth-child(1), &:nth-child(2) {
                    .filter {
                        .el-button--mini {
                            border-bottom: 1px solid rgba($alternate-color, .2);
                        }
                    }
                }
            }
        }
    }

    #advanced-search-mobile {
        display: none;

        .col {
            display: table;
            width: 100%;
            padding: 1em 0;
            border-top: 1px solid rgba($alternate-color, .2);

            &:first-child {
                border-top: none;
            }
        }

        @media (max-width: 767px) {
            display: initial;
        }
    }

    .Home {
        #reset-filters {
            display: none;
        }

        #filters-btn {
            display: none;
        }

        #advanced-search {
            display: none;
        }
    }

    .SearchResults {
        #home-filters-btn {
            display: none;
        }

        #advanced-search {
            .filter {
                box-shadow: inset 0 0 0 1px rgba($alternate-color, .2);
                border-radius: 3px;

                .el-button--mini {
                    border: none !important;

                    &:hover {
                        background: rgba($alternate-color, .05);
                    }
                }
            }

            .col {
                padding: .25em .25em .25em 0;

                &:last-child() {
                    padding: .25em 0;
                }
            }
        }
    }

    .el-popover {
        .el-slider__runway {
            margin: 10px 0;
        }

        .checkboxes {
            .el-checkbox {
                display: table;
                margin-top: .5em;
            }
        }

        .apply-btn {
            padding: .5em 0 0 0;
            margin-left: auto;
            display: table;

            &:hover {
                text-decoration: underline;
            }
        }
    }

    .advanced-search-popover {
        width: 100%;
        left: 0 !important;
        margin-top: 5px !important;
        border-radius: 0 !important;

        .popper__arrow {
            display: none!important;
        }
    }

    #filters-btn {
        display: none;
        margin: 10px 5px 0 0;
        padding: .35em .75em;
        font-weight: 700;
        text-transform: uppercase;
        font-size: .75em;
        letter-spacing: .25px;
        border-width: 1px!important;
        height: 23px;

        @media (max-width: 767px) {
            display: initial;
        }
    }
</style>

